import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "universal-cookie";
import apiError from "@/errors/api.error";
import { useSelector } from "react-redux";

export default (options = {}) => {
  const language = useSelector((state) => state.i18n.language);

  return useQuery({
    queryKey: ["personalDocuments"],
    queryFn: async () => {
      try {
        const res = await axios.get("/api/gateway/personal-documents", {
          headers: {
            authorization: `Bearer ${new Cookies().get("accessToken")}`,
          },
        });

        // Apply the same sorting logic as the Redux version
        const sortFunc = (a, b) => a.name.localeCompare(b.name, language);
        const sortDocuments = (documents) => {
          const folders = documents.children.filter(({ isFolder }) => isFolder);
          const files = documents.children.filter(({ isFolder }) => !isFolder);

          return {
            ...documents,
            children: [
              ...files.sort(sortFunc).map((c) => sortDocuments(c)),
              ...folders.sort(sortFunc).map((c) => sortDocuments(c)),
            ],
          };
        };

        return sortDocuments(res.data);
      } catch (e) {
        throw apiError.create(e.response.data.message);
      }
    },
    ...options,
  });
};
